import React from 'react';
import styles from './TRViewFacts.module.css';
import TRViwerTechnicalAnalisys from '../components/TRViwerTechnicalAnalisys';

function TRViewFacts(){
        
    return (                   
            
        <div className={styles.main_page}>
            <header className={styles.main_header}> 
                <h1>Market Indexes</h1>                       
            </header>
            <main>
                <section className={styles.content}>                            
                    <TRViwerTechnicalAnalisys symbol={'BTC.D'} />
                    <TRViwerTechnicalAnalisys symbol={'SPXUSD'} />
                    <TRViwerTechnicalAnalisys symbol={'TOTAL'} />
                    <TRViwerTechnicalAnalisys symbol={'DXY'} />
                </section>
            </main>
        </div>            
       
    );
}

export default TRViewFacts;






